import React, {createContext, useContext, useState} from 'react'
import {cloneObject} from "src/Lib/Helper/Functions";

/**
 * @step 1725- provider to keep plugs and services details.
 * @type {React.Context<undefined>}
 */

const VarContext = createContext();

export function useSrvSet() {
    return useContext(VarContext)
}

export function SrvSetProvider({children}) {
    const [srvSet, setSrvSet] = useState({});

    const changeSrvSet = (wrapper, key, value = null) => {
        const st = cloneObject(srvSet);
        if(!st[wrapper]) {
            st[wrapper] = {};
        }
        if(typeof key === "object") {
            for(let item of Object.keys(key)) {
                if(wrapper && item && key[item]) {
                    st[wrapper][item] = key[item];
                }
            }
        } else {
            st[wrapper][key] = value;
        }
        setSrvSet(st);
    }

    return (
        <VarContext.Provider value={{srvSet, changeSrvSet}}>
            {children}
        </VarContext.Provider>
    )
}
